import Logger       from '@/classes/Core/Logger'
import Config       from '@/classes/Core/Config'
import EventManager from '@/classes/Core/EventManager'
import UUID         from "@/classes/Helpers/UUID.js";

import { reactive } from "vue";
import Database     from "@/classes/Core/Database/Database";
import Crypto       from "@/classes/Core/Crypto";
import Provisioning from "@/classes/Core/Provisioning";
import WebSockets   from "@/classes/Core/WebSockets";
import KeyRing      from "@/classes/KeyRing";
import CoreTimer    from "@/classes/Core/CoreTimer";
import Functions    from "@/classes/Helpers/Functions";

export default class Core
{

    constructor( store, router )
    {

        if( !Core.instance )
        {

            this.store = store
            this.router = router
            this.setup()

            Core.instance = this

        }

        return Core.instance

    }

    setup()
    {
        this.states = reactive( new Map() )
        this.setState( 'criticalErrors', false )

        this.functions = new Functions()
        this.config = new Config()
        this.logger = new Logger( this )
        this.uuid = new UUID()
        this.database = new Database( this )
        this.eventManager = new EventManager( this )
        this.crypto = new Crypto( this.eventManager, this.store )
        this.coreTimer = new CoreTimer( this )
        this.keyRing = new KeyRing( this )
        this.websockets = new WebSockets( this )
        this.store.commit( 'setDatabase', this.database )
        this.store.commit( 'setEventManager', this.eventManager )
        this.provisioning = new Provisioning( this )

    }

    /**
     * basic state machine
     */
    setState( key, value )
    {

        let state  = this.states.get( key ),
            change = undefined !== state && value !== state

        this.states.set( key, value )

        if( change )
        {
            this.eventManager.dispatch( 'on-core-state-change-' + key, value )
        }

    }

    getState( key )
    {
        return this.states.get( key )
    }

    deleteState( key )
    {
        delete this.states.delete( key )
    }

    /**
     * getters
     */

    f()
    {
        return this.functions
    }

    getStore()
    {
        return this.store
    }

    getLogger()
    {
        return this.logger
    }

    getConfig()
    {
        return this.config
    }

    getUuid()
    {
        return this.uuid
    }

    getCrypto()
    {
        return this.crypto
    }

    getDatabase()
    {
        return this.database
    }

    getProvisioning()
    {
        return this.provisioning
    }

    getEventManager()
    {
        return this.eventManager
    }

    getKeyRing()
    {
        return this.keyRing
    }

    getCoreTimer()
    {
        return this.coreTimer
    }

    getWebsockets()
    {
        return this.websockets
    }

}